export default __webpack_public_path__ + "static/media/repairProcess.24be5a36.png";